import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  concat,
} from "@apollo/client";

const gqlLink = new HttpLink({
  uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const jwt = localStorage.getItem('jwt') || null;
  const authString = jwt && `Bearer ${jwt}`;
  operation.setContext({
    headers: {
      authorization: authString,
      jwtauth: authString,   // needed for dev.tomo ENV since it's Basic auth protected
    },
  });

  return forward(operation);
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, gqlLink),
});

export {
  client,
};